var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExperimental = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 18",
  "aria-hidden": "true",
  focusable: "false"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.088 17H2.912C1.28 17 .335 15.152 1.29 13.829l4.115-5.698a.5.5 0 0 0 .095-.293V3.31a.5.5 0 0 0-.276-.447l-.212-.106A.927.927 0 0 1 5.427 1h3.146a.927.927 0 0 1 .415 1.756l-.212.106a.5.5 0 0 0-.276.447v4.53a.5.5 0 0 0 .095.292l4.115 5.698c.955 1.323.01 3.171-1.622 3.171Z"
})));
export default SvgExperimental;